import {
  types,
  IDataPollingAction,
  SuccessActionCreatorType,
  FailureActionCreatorType,
} from '../types/polling'

export const dataPollingAction = (
  location: string,
  startTime: number,
  successAction: SuccessActionCreatorType,
  failureAction: FailureActionCreatorType,
  options = {}
): IDataPollingAction => ({
  type: types.DATA_POLLING__STARTED,
  location,
  startTime,
  successAction,
  failureAction,
  options,
})
